<template>
    <div>
      <div id="map" style="width:100%; height:500px"></div>
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    </div>
  </template>
  
  <script>
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import * as turf from "@turf/turf";
import { center } from "@turf/turf";
  
  export default {
    name: 'HereMap',
    components: {
      BaseFormLoading
    },
    props: {
      item: Object,
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
    },
    data() {
      return {
        loading: { value: true },
        centerMap: {
          lat: 21.0284743,
          lng: 105.8500046
        },
        devices: []
      }
    },
    mounted() {
      let that = this;
      that.loadDataMap();
      setTimeout(() => {
        that.initMap();
      }, 1000)
    },
    methods: {
      initMap() {
        let that = this;
        const platform = new H.service.Platform({
          apikey: 'VsN3Wj8MACjnvLHRzTUE0VQvd0_HIGEveOXj5buVAfc',
          // 3BGMlvG3FCiYQwbFY8jr
          // useCIT: true,
          // lg: 'vi-VN',
          // app_id: 'YOUR_APP_ID', // Replace with your actual App ID if required
          // app_code: 'YOUR_APP_CODE', // Replace with your actual App Code if required
        });
  
        const defaultLayers = platform.createDefaultLayers(
          {
            lg: 'vi',
            lg2: 'vi'
          }
        );
  
        const map = new H.Map(
          document.getElementById("map"),
          defaultLayers.vector.normal.map,
          {
            zoom: 15,
            pixelRatio: window.devicePixelRatio || 1
          },
          'vi'
        );

        map.setCenter({lat: that.centerMap.lat, lng: that.centerMap.lng});

        // Đăng ký sự kiện khi bản đồ đã tải xong
        map.addEventListener('mapviewchangeend', function () {
          var iconBlue = {
            url: '/static/img/location-blue.png', // Đường dẫn đến biểu tượng màu xanh
            size: { w: 26, h: 35 },
          }
          var markerIconBlue = new H.map.Icon(iconBlue.url, {
            size: iconBlue.size,
          });

          var iconRed = {
            url: '/static/img/location-red.png', // Đường dẫn đến biểu tượng màu xanh
            size: { w: 26, h: 35 },
          }
          var markerIconRed= new H.map.Icon(iconRed.url, {
            size: iconRed.size,
          });

          for(var i = 0; i < that.devices.length; i++) {
            var location = { lat: that.devices[i].latitude, lng: that.devices[i].longitude, code: that.devices[i].code, description: that.devices[i].description }
            
            if(that.devices[i].connectStatus != 1) {
              var marker = new H.map.Marker({ lat: location.lat, lng: location.lng }, {
                icon: markerIconRed,
                visibility: true
              });
              marker.setData(location);
              map.addObject(marker);
            } else {
              var marker = new H.map.Marker({ lat: location.lat, lng: location.lng }, {
                icon: markerIconBlue,
                visibility: true
              });
              marker.setData(location);
              map.addObject(marker);
            }
          }

          that.loading.value = false;
        });
  
  
        window.addEventListener('resize', () => map.getViewPort().resize());
  
        // const svg = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" viewBox="0 0 100 100">
        //   <circle cx="50" cy="50" r="50" fill="rgb(30, 200, 200)" opacity=".8"/>
        //   <circle cx="50" cy="50" r="4" fill="black"/>
        //   </svg>`;
        // var domMarker = new H.map.DomMarker({ lat: 21.0245, lng: 105.8412 }, {
        //   icon: new H.map.DomIcon(svg)
        // })
        // domMarker.setData({
        //   name: 'ABC'
        // })
        // map.addObject(domMarker);
  
  
        // Enable the event system on the map instance:
  
        const mapEvents = new H.mapevents.MapEvents(map);
  
        // // Add event listeners:
        map.addEventListener('tap', function (evt) {
          var target = evt.target;
          if (target instanceof H.map.Marker) {
            var data = target.getData();
            if (data) {
              var infobubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
                content: `<div>
                    <span>Mã thiết bị: <b>${data.code}</b></span></br>
                    <span>Tên thiết bị: <b>${data.description}</b></span></br>
                    <span>Vị trí: <b>${data.lat},${data.lng}</b></span></br>
                    <span><a href="https://www.google.com/maps/dir/?api=1&destination=${data.lat},${data.lng}&travelmode=driving" target="_blank">Chỉ đường</a></span>
                  </div>`
              });
              ui.addBubble(infobubble);
            }
          }
        });
  
        // Instantiate the default behavior, providing the mapEvents object:
        const behavior = new H.mapevents.Behavior(mapEvents);
  
        // Create the default UI:
        const ui = H.ui.UI.createDefault(map, defaultLayers);
        ui.setUnitSystem(H.ui.UnitSystem.METRIC);
  
        const mapSettingsControl = ui.getControl('mapsettings');
        // mapSettingsControl.setAlignment('top-left');
        mapSettingsControl.setVisibility(false);
  
        const zoomControl = ui.getControl('zoom');
        // zoomControl.setVisibility(false);
        // zoomControl.setDisabled(true);
  
        const zoomRectangle = new H.ui.ZoomRectangle({
          // Position the control on the map's viewport
          alignment: H.ui.LayoutAlignment.RIGHT_BOTTOM
        });
        ui.addControl('rectangle', zoomRectangle);
  
      },

      loadDataMap() {
        let that = this;
        that.$helper.loadDataSource({
            url: "/devices/get-device-by-map",
            dataSubmit: function () {
            },
            successCallback: function (response) {
              
              that.devices = response.data.data;
              that.calculateCenter(response.data.data)
            },
            errorCallback: function (error) {
              that.$helper.handleError(that.$router, error);
            }
          });
      },
      
      calculateCenter(coordinates) {
        const validCoordinates = coordinates.filter(coord => 
          !isNaN(Number(coord.latitude)) && !isNaN(Number(coord.longitude))
        );
        const points = validCoordinates.map(coord => turf.point([Number(coord.longitude), Number(coord.latitude)]));
        const center = turf.center(turf.featureCollection(points));
        this.centerMap = {lat: center.geometry.coordinates[1], lng: center.geometry.coordinates[0]};
      }
    },
  };
  </script>
  
  <style>
  #map {
    width: 100%;
    height: 100%;
    background-color: gray;
  }
  
  .svg-icon {
    width: 28px;
    height: 28px;
    margin: -14px 0 0 -14px;
    opacity: 0.4;
    transition: opacity 0.5s;
  }
  
  .svg-icon:hover {
    opacity: 1;
    cursor: pointer;
  }
  </style>
  